<h2>Certifications <button class="icon--add btn--default" type="button" (click)="addCertification()" *ngIf="canEdit">Add Certification</button><button class="icon--history btn--default" type="button" (click)="showHistory(customerNumber)">View History</button></h2>
<p-table #dt [value]="certifications" styleClass="p-datatable-striped">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="4 + (!!canEdit ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Type</th>
            <th>Description</th>
            <th>Effective Date</th>
            <th>Expiration Date</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{data.certificationType}}</td>
            <td>{{data.description}}</td>
            <td>{{data.effectiveDate | shortDate}}</td>
            <td>{{data.expirationDate | shortDate}}</td>
            <td class="text-center" *ngIf="canEdit"> <a class="icon--edit" title="Edit Certification" href="javascript:void(0);" (click)="editCertification(data.id)"></a></td>
        </tr>
    </ng-template>
</p-table>